/** @format */
import { createSlice } from "@reduxjs/toolkit";
import { ILocation } from "lobbie";
import {
    setLocation,
    setLocationId,
    setLocations,
    setMultiMultiLocations,
} from "../actions/locationActions";

// TODO: Cleanup state definition; what is the difference between locations and multiLocations? location is... "current" location? location being edited? how is location related to locationId?
export type LocationState = {
    locationId?: number;
    location?: ILocation;
    locations?: ILocation[];
    multiLocations?: ILocation[];
};

const initialState: LocationState = {};

const locationSlice = createSlice({
    name: "locationSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(setLocations, (state, action) => ({
                ...state,
                locations: action.payload,
            }))
            .addCase(setLocation, (state, action) => ({
                ...state,
                location: action.payload,
            }))
            .addCase(setLocationId, (state, action) => ({
                ...state,
                locationId: action.payload,
            }))
            .addCase(setMultiMultiLocations, (state, action) => ({
                ...state,
                multiLocations: action.payload,
            })),
});

export default locationSlice;
